(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Reveal on scroll (safe: only activates when supported) ---
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('jrv-on');
    // Apply reveal to a curated, non-critical set — no template edits required.
    var stagger = ['.nos-garanties__grid'];
    var up = ['.nos-garanties__title', '.em-sec__title', '.johya-ped-title', '.johya-cat-title', '.notre-demarche__title'];
    stagger.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { el.classList.add('jrv-stagger'); });
    });
    up.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { el.classList.add('jrv-up'); });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('jrv-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.18 });
    document.querySelectorAll('.jrv-fade,.jrv-up,.jrv-stagger').forEach(function (el) { io.observe(el); });
  }

  // --- Sticky buy bar (mobile) ---
  var bar = document.querySelector('[data-jsb]');
  var form = document.querySelector('product-form form, form[action*="/cart/add"], .em-form');
  if (bar && form) {
    bar.hidden = false;
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (e) {
        bar.classList.toggle('jsb-visible', !e[0].isIntersecting);
      }, { threshold: 0 });
      io2.observe(form);
    }
    var buy = bar.querySelector('[data-jsb-buy]');
    if (buy) {
      buy.addEventListener('click', function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }
})();
